export const PALACE_CAPTURE_WIN_POINTS = 4;
export const FORTRESS_CAPTURE_WIN_POINTS = 2;
